import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Layout/index.vue";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "LoginItem",
    component: () => import("../views/Login/index.vue"),
    meta: {
      title: "Authorization",
    },
  },
  {
    path: "/app",
    name: "LayoutItem",
    component: Layout,
    children: [
      {
        path: "home",
        name: "HomeItem",
        component: () => import("../views/Home/index.vue"),
        meta: { title: "Main", id: "62ccd055-648c-45da-963b-db58cee07e05" },
      },
      {
        path: "guide",
        name: "GuideItem",
        component: () => import("../views/Guide/index.vue"),
        meta: { title: "Guides", id: "" },
      },
      {
        path: "patients",
        name: "PatientsItem",
        component: () => import("../views/Patients/index.vue"),
        meta: { title: "Patients", id: "" },
      },
      {
        path: "patients-epicris/:id",
        name: "PatientsEpicris",
        component: () => import("../views/Patients/components/Epicris.vue"),
        meta: { title: "Viewing the medical summary" },
      },
      {
        path: "roles",
        name: "Roles",
        component: () => import("../views/Roles/index.vue"),
        meta: {
          title: "Roles",
          id: "6e6553a1-e4d6-4a45-a8f9-e018adc77550",
        },
      },
      {
        path: "administrator-profile",
        name: "administratorProfile",
        component: () => import("../views/AdministratorProfile/index.vue"),
        meta: { title: "Profile", id: "6a15388c-28f3-49f6-97e0-c6c816f44d5c" },
      },
      {
        path: "doctor-profile",
        name: "doctorProfile",
        component: () => import("../views/DoctorProfile/index.vue"),
        meta: { title: "Profile", id: "6a15388c-28f3-49f6-97e0-c6c816f44d5c" },
      },
      {
        path: "expert-profile",
        name: "expertProfile",
        component: () => import("../views/ExpertProfile/index.vue"),
        meta: { title: "Profile", id: "6a15388c-28f3-49f6-97e0-c6c816f44d5c" },
      },
      {
        path: "reports",
        name: "Reports",
        component: () => import("../views/Reports/index.vue"),
        meta: { title: "Reports", id: "" },
      },
      {
        path: "sections",
        name: "Sections",
        component: () => import("../views/SectionSystem/index.vue"),
        meta: {
          title: "System Modes",
          id: "64107279-9dfb-4f7f-9c16-f1ffbc5ce185",
        },
      },
      {
        path: "users",
        name: "Users",
        component: () => import("../views/Users/index.vue"),
        meta: {
          title: "Users",
          id: "0a6805dc-8627-488d-81b0-cc6f2f0b6723",
        },
      },
      // Дальше разделы справочников
      // Дальше разделы справочников
      // Дальше разделы справочников
      {
        path: "anamnesis",
        name: "SprAnamnesis",
        component: () => import("../views/Guide/GuideList/Anamnesis.vue"),
        meta: { title: "Anamnesis", id: "" },
      },
      {
        path: "mental-function",
        name: "SprMentalFunction",
        component: () => import("../views/Guide/GuideList/MentalFunction.vue"),
        meta: { title: "Mental function", id: "" },
      },
      {
        path: "physical-indicator",
        name: "SprVitalIndicator",
        component: () =>
          import("../views/Guide/GuideList/PhysicalIndicator.vue"),
        meta: { title: "Vital indicator", id: "" },
      },
      {
        path: "symptom",
        name: "SprSymptom",
        component: () => import("../views/Guide/GuideList/Symptom.vue"),
        meta: { title: "Symptoms", id: "" },
      },
      {
        path: "physical-research",
        name: "SprPhysicalResearch",
        component: () =>
          import("../views/Guide/GuideList/PhysicalResearch.vue"),
        meta: {
          title: "Physical research",
          id: "",
        },
      },
      {
        path: "phys-research",
        name: "SprPhysResearch",
        component: () => import("../views/Guide/GuideList/PhysResearch.vue"),
        meta: { title: "Physical research methods", id: "" },
      },
      {
        path: "analyzers-guide",
        name: "SprAnalyzer",
        component: () => import("../views/Guide/GuideList/Analyzers.vue"),
        meta: { title: "Analyzers", id: "" },
      },
      {
        path: "body-parts",
        name: "SprBodyPart",
        component: () => import("../views/Guide/GuideList/BodyParts.vue"),
        meta: { title: "Body parts", id: "" },
      },
      {
        path: "specialties",
        name: "SprSpeciality",
        component: () => import("../views/Guide/GuideList/Specialties.vue"),
        meta: { title: "Speciality", id: "" },
      },
      {
        path: "units-of-measurement",
        name: "SprMeasurement",
        component: () =>
          import("../views/Guide/GuideList/UnitsOfMeasurement.vue"),
        meta: { title: "Units of measurement", id: "" },
      },
      {
        path: "body-systems",
        name: "SprBodySystem",
        component: () => import("../views/Guide/GuideList/BodySystems.vue"),
        meta: { title: "Body systems", id: "" },
      },
      {
        path: "analyzers-and-um",
        name: "SprAnalyzerMeasurement",
        component: () =>
          import("../views/Guide/GuideList/AnalyzersAndUnitsOfMeasurement.vue"),
        meta: { title: "Analyzers and units of measurement", id: "" },
      },
      {
        path: "instrumental-research",
        name: "SprInstrumentalResearch",
        component: () =>
          import("../views/Guide/GuideList/InstrumentalResearch.vue"),
        meta: { title: "Instrumental research", id: "" },
      },
      {
        path: "laboratory-research",
        name: "SprLabResearch",
        component: () => import("../views/Guide/GuideList/LaboratoryTests.vue"),
        meta: { title: "Laboratory tests", id: "" },
      },
      {
        path: "mkb-10",
        name: "SprMkb10",
        component: () => import("../views/Guide/GuideList/Mkb10.vue"),
        meta: { title: "ICD-10 code", id: "" },
      },
      {
        path: "mkb-11",
        name: "SprMkb11",
        component: () => import("../views/Guide/GuideList/Mkb11.vue"),
        meta: { title: "ICD-11 code", id: "" },
      },
      {
        path: "somatic-status",
        name: "SprSomatic",
        component: () => import("../views/Guide/GuideList/SomaticStatus.vue"),
        meta: { title: "Somatic status", id: "" },
      },
      {
        path: "antropometric",
        name: "SprAnthropometricIndicator",
        component: () => import("../views/Guide/GuideList/Antropometric.vue"),
        meta: { title: "Anthropometric measurements", id: "" },
      },
      {
        path: "diff-diagnostic",
        name: "SprDiagnostics",
        component: () =>
          import("../views/Guide/GuideList/DifferentialDiagnostic.vue"),
        meta: { title: "Indicators for differential diagnosis", id: "" },
      },
      {
        path: "indication-hospitalizations",
        name: "SprIndicationHospitalization",
        component: () =>
          import("../views/Guide/GuideList/IndicationHospitalizations.vue"),
        meta: { title: "Показания для госпитализации", id: "" },
      },
      {
        path: "routing",
        name: "SprRouting",
        component: () => import("../views/Guide/GuideList/Routing.vue"),
        meta: { title: "Indications for hospitalization", id: "" },
      },
      {
        path: "duration",
        name: "SprDuration",
        component: () => import("../views/Guide/GuideList/Duration.vue"),
        meta: { title: "Duration", id: "" },
      },
      {
        path: "appointment-frequency",
        name: "SprAppointmentFrequency",
        component: () =>
          import("../views/Guide/GuideList/AppointmentFrequency.vue"),
        meta: { title: "Appointment frequency", id: "" },
      },
      {
        path: "medicine-product-group",
        name: "SprMedicineProductGroup",
        component: () =>
          import("../views/Guide/GuideList/MedicineProductGroup.vue"),
        meta: { title: "Medicine product group", id: "" },
      },
      {
        path: "medicine-product",
        name: "SprMedicineProduct",
        component: () => import("../views/Guide/GuideList/MedicineProduct.vue"),
        meta: { title: "Medicine products", id: "" },
      },
      {
        path: "typical-assignments",
        name: "SprTypicalMedication",
        component: () =>
          import("../views/Guide/GuideList/TypicalAssignments.vue"),
        meta: { title: "Typical medication", id: "" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title =
    toRoute.meta && toRoute.meta.title ? toRoute.meta.title : "Главная";

  next();
});

export default router;
